import React from 'react';
import Acilir from './Acilir';

/**
 * "Hesaplama adımları" — animasyonlu, varsayılan kapalı açılır panel.
 * adimlar: [{ label, val, sub }]; extNote: opsiyonel açıklama metni (tatil uzatması).
 */
function HesaplamaAdimlari({ adimlar, extNote }) {
  return (
    <Acilir baslik="Hesaplama adımları" className="mt-4">
      <div className="border-t border-slate-100 px-4 pb-4 pt-3">
        {adimlar.map((a, i) => (
          <div
            key={i}
            className="flex gap-3 border-t border-dashed border-slate-200 py-2 text-sm first:border-t-0"
          >
            <span className="flex-1 text-slate-600">{a.label}</span>
            <span className="whitespace-nowrap text-right font-semibold text-slate-800">
              <span className="app-num">{a.val}</span>
              {a.sub ? <small className="block font-medium text-slate-400">{a.sub}</small> : null}
            </span>
          </div>
        ))}
        {extNote ? (
          <div className="mt-3 rounded-lg bg-amber-50 px-3 py-2.5 text-xs leading-relaxed text-amber-800 ring-1 ring-inset ring-amber-200/70">
            {extNote}
          </div>
        ) : null}
      </div>
    </Acilir>
  );
}

export default HesaplamaAdimlari;
